import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { AuthProvider } from "./lib/auth";
import { ToastProvider } from "./components/ui";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import { isRetryableApiError } from "./lib/api";
import { installGlobalErrorHandlers } from "./lib/client-errors";
import { router } from "./router";
import "./styles.css";
import "./features/stock/stock.css";
import "@xyflow/react/dist/style.css";
import "./styles/comfort.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: (attempt, error) => attempt < 1 && isRetryableApiError(error)
    },
    mutations: { retry: false }
  }
});

installGlobalErrorHandlers();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </AuthProvider>
      </QueryClientProvider>
    </AppErrorBoundary>
  </StrictMode>
);
